import { TAB_HIDE, TAB_SHOW } from '../../../../../common/tabs/tabs.constants';
import { IDS } from '../pnp-doc.constants';
import { getDocumentHistoryDetails, getDocumentReviewerApproverDetails  ,deleteAccreditationDocument} from '../pnp-doc.actions';
import { getAccreditationSchemes  } from '../../pnp-docs.actions';
/**
 * @const {object}
 * @memberOf module:policies
 */
export const pnpDocumentAccreditation = {
    /* @ngInject */
    controller: function ($ngRedux, $state, $mdDialog, $rootScope,Notifier) {
        /**
         * @function $onInit
         */
        this.$onInit = () => {
            this.unsubscribe = $ngRedux.connect(({ policies }) => ({
                pnpDocument: policies.pnpDocument
            }), {
                getDocumentHistoryDetails,
                getDocumentReviewerApproverDetails,
                deleteAccreditationDocument,
                getAccreditationSchemes,
            })(this);
            this.getAccreditationSchemes();
        }

        this.onRemove = ({ item }) => {
            const confirm = $mdDialog.confirm()
                .title('Delete Accreditation Document')
                .textContent('Are you sure? The chosen accreditation document will be deleted.')
                .ariaLabel('Delete document')
                .ok('Yes')
                .cancel('No');
            this.dialog = $mdDialog.show(confirm).then(() => {
                Notifier.success('Accreditation Document is delete successfully.');
                this.deleteAccreditationDocument(item.documentAccreditationSchemesId);
            }, angular.noop);
        };

        this.onReset = (event) => {
            $rootScope.$broadcast('SELECT_CASCADE_RESET', 'pnpAccrediationDocumentFilterForm');
        };

        this.$onDestroy = () => {
            this.unsubscribe();
            clearTimeout(this.timeout);
        }

        this.handleCustomAction=()=> {
            $ngRedux.dispatch({
                type: TAB_HIDE,
                id: IDS.app_policies_documents_manage,
                state: [IDS.app_policies_documents_accreditation_add_details]
            });

            this.timeout = setTimeout(() => {
                $ngRedux.dispatch({
                    type: TAB_SHOW,
                    id: IDS.app_policies_documents_manage,
                    state: [IDS.app_policies_documents_accreditation_add_details],
                });
            }, 1000);
        }
    },

    template: `
    <div layout-xs="column" layout-gt-xs="row" layout-align-xs="center center" layout-align-gt-xs="end end">
        <md-button class="btnColorAccreditations" ng-click="$ctrl.handleCustomAction()">Add Accreditation</md-button>
    </div>
    <pnp-document-accreditation-grid 
        on-remove="$ctrl.onRemove($event)"
        on-reset="$ctrl.onReset($event)">
    </pnp-document-accreditation-grid>
`
};
